export const learningEventTypes = [
  "session_started",
  "scene_entered",
  "content_viewed",
  "interaction_completed",
  "archive_opened",
  "archive_completed",
  "source_viewed",
  "narration_changed",
  "task_answered",
  "hint_used",
  "remediation_started",
  "remediation_completed",
  "evidence_awarded",
  "report_viewed",
  "scene_exited",
  "scene_completed",
  "quality_changed",
  "performance_sample",
  "resource_failed",
  "webgl_fallback",
] as const;

export type LearningEventType = (typeof learningEventTypes)[number];

export interface LearningEvent {
  eventId: string;
  occurredAt: string;
  sessionId: string;
  participantId: string;
  appVersion: string;
  contentVersion: string;
  type: LearningEventType;
  sceneId?: string;
  taskId?: string;
  durationMs?: number;
  payload: Record<string, string | number | boolean | null>;
}

export function createLearningEvent(
  event: Omit<LearningEvent, "eventId" | "occurredAt">,
): LearningEvent {
  return {
    ...event,
    eventId: crypto.randomUUID(),
    occurredAt: new Date().toISOString(),
  };
}

export function anonymizeEvents(events: readonly LearningEvent[]): LearningEvent[] {
  return events.map((event) => ({
    ...event,
    participantId: `anon-${event.participantId.slice(-6)}`,
    payload: Object.fromEntries(
      Object.entries(event.payload).filter(
        ([key]) => !["name", "studentId", "major", "className"].includes(key),
      ),
    ),
  }));
}
